import {t} from '@lingui/macro'
import type {FC} from 'react'
import {useEffect} from 'react'

import {useToaster} from '~/shell/toaster'
import {useScript} from '~/web-platform/use-script'

interface CalendlyProps {
    dataUrl: string
    minWidth: string
    height: string
    email: string
    name: string
    hideDetails?: boolean
    onEventScheduled?: () => void
    onProfilePageViewed?: () => void
    onStart?: () => void
}

export const Calendly: FC<CalendlyProps> = ({
    dataUrl,
    minWidth,
    height,
    email,
    name,
    hideDetails,
    onEventScheduled,
    onProfilePageViewed,
    onStart,
}) => {
    const {showToast} = useToaster()
    useEffect(() => {
        const eventHandler = (e: MessageEvent) => {
            if (
                e.data.event?.indexOf('calendly') === 0 &&
                e.data.event === 'calendly.event_scheduled'
            ) {
                onEventScheduled?.()
            }

            if (
                e.data.event?.indexOf('calendly') === 0 &&
                e.data.event === 'calendly.profile_page_viewed'
            ) {
                onProfilePageViewed?.()
            }
        }

        window.addEventListener('message', eventHandler)

        return () => {
            window.removeEventListener('message', eventHandler)
        }
    }, [])

    const [, error] = useScript('https://assets.calendly.com/assets/external/widget.js')
    useEffect(() => {
        if (error) {
            showToast(t`Calendly widget is not loaded`, {level: 'error'})
        } else {
            onStart?.()
        }
    }, [error])

    return (
        <div
            data-testid="calendly"
            className="calendly-inline-widget"
            data-url={`${dataUrl}?name=${name}&email=${email}${
                hideDetails ? '&hide_event_type_details=1' : ''
            }`}
            style={{minWidth, height}}
            data-generic-ui="calendly"
        />
    )
}
